import Vue from 'vue'
import { get, post } from '@/utils/Api'
import UrlStore from '@/utils/UrlStore'
import * as PN from '@/utils/PermissionNames'

export default {
  namespaced: true,
  state: {
    scimSettings: {
      scim_enabled: false,
      scim_token: '',
      scim_token_updated_at: '',
      scim_employees_sync: false
    },
    samlSettings: {
      saml_enabled: false,
      saml_entity_id: '',
      saml_x509_cert: '',
      saml_sso_url: '',
      saml_slo_url: ''
    }
  },
  getters: {
    scimUsersSyncEnabled(state) {
      return state.scimSettings.scim_enabled
    },
    scimEmployeesSyncEnabled(state) {
      return state.scimSettings.scim_enabled && state.scimSettings.scim_employees_sync
    },
    canControl(state, getters, rootState, rootGetters) {
      return rootGetters['rbac/can'](PN.SETTINGS_CRUD)
    },
    samlEnabled(state) {
      return state.samlSettings.saml_enabled
    }
  },
  actions: {
    loadAll({ dispatch, getters }) {
      if (getters.canControl) {
        dispatch('loadScimSettings')
        dispatch('loadSamlSettings')
      }
    },
    async loadScimSettings({ rootState, commit }) {
      if (rootState.auth.user.scim_sync_enabled) {
        const response = await get(UrlStore.SCIM_SETTINGS)
        commit('setScimSettings', response.data)
      }
    },
    async loadSamlSettings({ commit }) {
      const response = await get(UrlStore.SAML_SETTINGS)
      commit('setSamlSettings', response.data)
    },
    async saveScimSettings({ commit }, settings) {
      const response = await post(UrlStore.SCIM_SETTINGS, settings)
      commit('setScimSettings', response.data)
    },
    async saveSamlSettings({ commit }, settings) {
      const response = await post(UrlStore.SAML_SETTINGS, settings)
      commit('setSamlSettings', response.data)
    }
  },
  mutations: {
    setScimSettings(state, payload) {
      Vue.set(state, 'scimSettings', { ...state.scimSettings, ...payload })
    },
    setSamlSettings(state, payload) {
      Vue.set(state, 'samlSettings', { ...state.samlSettings, ...payload })
    }
  }
}
